import React from "react";
import Main from "./Main";
import Header from "./Header";
import Footer from "./Footer";
import "../../styles/home.css";

const Home = () => {
  return (
    <>
      <Header />
      <Main />
      <Footer />
    </>
  );
};

export default Home;
